export async function fetchProductPages(loggedIn) {
  const URL_ELEMENT = document.querySelector('[data-fetch-from]');
  if (!URL_ELEMENT) return;
  const API_URL = URL_ELEMENT.getAttribute('data-fetch-from');

  const FETCH_DATA = await fetch(API_URL, {
    method: "POST",
    headers: {
      Authorization: "Basic " + btoa('api@farnschlaeder.de' + ":" + 'RTU1jeu0yfp3xyk_mfw'),
      "Content-Type": "application/json",
      Accept: "application/json",
    },

    body: JSON.stringify({
      select: {
        productPageInfos: {
          query: `site.index(false).findBy('intendedTemplate', 'order').children.listed`,
          select: {
            productId: 'page.intendedTemplate',

            priceTable: loggedIn ? 'page.user_price_table.toStructure' : 'page.price_table.toStructure',
            squareMeterPrice: loggedIn ? 'page.user_square_meter_value.value' : 'page.square_meter_value.value',

            heightSurchargeValue: loggedIn ? 'page.user_height_surcharge.value' : 'page.height_surcharge.value',
            heightSurchargeTable: loggedIn ? 'page.user_height_surcharge_structure.toStructure' : 'page.height_surcharge_structure.toStructure',

            widthSurchargeTable: loggedIn ? 'page.user_width_surcharge_structure.toStructure' : 'page.width_surcharge_structure.toStructure',

            discountPercent20: loggedIn ? 'page.user_discount_quantity_percent.value' : 'page.discount_quantity_percent.value',
            discountPercent300: loggedIn ? 'page.user_discount_percent_300.value' : 'page.discount_percent_300.value',
            discountPercent600: loggedIn ? 'page.user_discount_percent_600.value' : 'page.discount_percent_600.value',
            discountPercent1000: loggedIn ? 'page.user_discount_percent_1000.value' : 'page.discount_percent_1000.value',

            surchargeStripsPercent: loggedIn ? 'page.user_surcharge_strips_value.value' : 'page.surcharge_strips_value.value',
            surchargeDoublePercent: loggedIn ? 'page.user_surcharge_double_value.value' : 'page.surcharge_double_value.value',
            surchargeLuxaflexPercent: loggedIn ? 'page.user_surcharge_luxaflex_value.value' : 'page.surcharge_luxaflex_value.value',
            surchargeElectroPercent: loggedIn ? 'page.user_surcharge_electro_value.value' : 'page.surcharge_electro_value.value',

            surchargeMoldPercent: loggedIn ? 'page.user_surcharge_mold_value.value' : 'page.surcharge_mold_value.value',
            surchargeDualFabricPercent: loggedIn ? 'page.user_surcharge_dual_fabric_value.value' : 'page.surcharge_dual_fabric_value.value',
            surchargeDuetPercent: loggedIn ? 'page.user_surcharge_duet_value.value' : 'page.surcharge_duet_value.value',
            surchargePlafondPercent: loggedIn ? 'page.user_surcharge_plafond_value.value' : 'page.surcharge_plafond_value.value',

            repairSurchargeValue: loggedIn ? 'page.user_repair_surcharge_value.value' : 'page.repair_surcharge_value.value',
            repairAndCleanSurchargeValue: loggedIn ? 'page.user_repair_and_clean_surcharge_value.value' : 'page.repair_and_clean_surcharge_value.value',
            repairExtraWidthSurchargeValue: loggedIn ? 'page.user_repair_width_surcharge_value.value' : 'page.repair_width_surcharge_value.value',
            repairDualFabricSurchargeValue: loggedIn ? 'page.user_repair_dual_fabric_surcharge_value' : 'page.repair_dual_fabric_surcharge_value',
          }
        },
        shippingInfos: {
          query: `site.index(false).findBy('intendedTemplate', 'order-shipping')`,
          select: {
            all_inclusive_surcharge_110: loggedIn ? 'page.user_all_inclusive_surcharge_110.value' : 'page.all_inclusive_surcharge_110.value',
            all_inclusive_surcharge_135: loggedIn ? 'page.user_all_inclusive_surcharge_135.value' : 'page.all_inclusive_surcharge_135.value',
            all_inclusive_surcharge_185: loggedIn ? 'page.user_all_inclusive_surcharge_185.value' : 'page.all_inclusive_surcharge_185.value',
            stretch_film_cost: loggedIn ? 'page.user_stretch_film_cost.value' : 'page.stretch_film_cost.value',
            package_surcharge_dhl: loggedIn ? 'page.user_package_surcharge_dhl.value' : 'page.package_surcharge_dhl.value',
            package_surcharge_gls: loggedIn ? 'page.user_package_surcharge_gls.value' : 'page.package_surcharge_gls.value',
            package_surcharge_gls_pickup: loggedIn ? 'page.user_package_surcharge_gls_pickup.value' : 'page.package_surcharge_gls_pickup.value',
            package_surcharge_dhl_pickup: loggedIn ? 'page.user_package_surcharge_dhl_pickup.value' : 'page.package_surcharge_dhl_pickup.value',
            diy_extra_surcharge_235: loggedIn ? 'page.user_diy_extra_surcharge_235.value' : 'page.diy_extra_surcharge_235.value',
            diy_extra_surcharge_285: loggedIn ? 'page.user_diy_extra_surcharge_285.value' : 'page.diy_extra_surcharge_285.value',
            retoure_surcharge_110: loggedIn ? 'page.user_retoure_surcharge_110.value' : 'page.retoure_surcharge_110.value',
            retoure_surcharge_135: loggedIn ? 'page.user_retoure_surcharge_135.value' : 'page.retoure_surcharge_135.value',
            retoure_surcharge_185: loggedIn ? 'page.user_retoure_surcharge_185.value' : 'page.retoure_surcharge_185.value',
            retoure_surcharge_290: loggedIn ? 'page.user_retoure_surcharge_290.value' : 'page.retoure_surcharge_290.value'
          }
        }
      }
    })
  })

  return await FETCH_DATA.json();
}
